var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { buildGeminiWeekPeriodTooltipLabel } from '@web/components/Apps/Gemini/geminiChartTooltipLabels';
import { formatGeminiUsageLevelLabel } from '@web/components/Apps/Gemini/geminiUsageLevel';
import { GEMINI_USAGE_LEVEL_COLORS_CONFIG } from '@web/config';
import { GeminiUsageLevelEnum } from '@workalizer/shared';
import { GEMINI_USAGE_LEVEL_RANK, GEMINI_USAGE_LEVELS } from '@workalizer/shared/lib/gemini-usage-level';
import { toPercent } from '@workalizer/shared/utils';
export var geminiAdoptionTrendTeamDataKey = function (prefix, level) { return "".concat(prefix).concat(level.charAt(0)).concat(level.slice(1).toLowerCase()); };
export var GEMINI_ADOPTION_TREND_TEAM_BAR_CHART_CONFIGS = {
    previous: GEMINI_USAGE_LEVELS.map(function (level) { return ({
        dataKey: geminiAdoptionTrendTeamDataKey('previous', level),
        fill: GEMINI_USAGE_LEVEL_COLORS_CONFIG[level].prevChartColor,
        stackId: 'previous'
    }); }),
    current: GEMINI_USAGE_LEVELS.map(function (level) { return ({
        dataKey: geminiAdoptionTrendTeamDataKey('current', level),
        fill: GEMINI_USAGE_LEVEL_COLORS_CONFIG[level].chartColor,
        stackId: 'current'
    }); })
};
export var GEMINI_ADOPTION_TREND_TEAM_PREVIOUS_STACK_DATA_KEYS = GEMINI_ADOPTION_TREND_TEAM_BAR_CHART_CONFIGS.previous.map(function (config) { return config.dataKey; });
export var GEMINI_ADOPTION_TREND_TEAM_CURRENT_STACK_DATA_KEYS = GEMINI_ADOPTION_TREND_TEAM_BAR_CHART_CONFIGS.current.map(function (config) { return config.dataKey; });
var appendTeamLevelShares = function (row, prefix, levels, usersInScope) {
    for (var _i = 0, GEMINI_USAGE_LEVELS_1 = GEMINI_USAGE_LEVELS; _i < GEMINI_USAGE_LEVELS_1.length; _i++) {
        var level = GEMINI_USAGE_LEVELS_1[_i];
        row[geminiAdoptionTrendTeamDataKey(prefix, level)] = toPercent(levels[level], usersInScope);
    }
};
export var buildGeminiAdoptionTrendTeamChartData = function (data, options) {
    return data.weeks.map(function (week) {
        var row = {
            name: week.period,
            period: week.period,
            dateFrom: week.dateFrom,
            dateTo: week.dateTo,
            previousDateFrom: week.previousDateFrom,
            previousDateTo: week.previousDateTo,
            levelCounts: week.levels,
            previousLevelCounts: week.previousLevels,
            usersInScope: data.usersInScope
        };
        if (options.filterPeriodLabels) {
            row.currentPeriodComparisonLabel =
                options.filterPeriodLabels.currentPeriodComparisonLabel;
            row.previousPeriodLabel = options.filterPeriodLabels.previousPeriodLabel;
        }
        else {
            row.currentPeriodComparisonLabel = buildGeminiWeekPeriodTooltipLabel(week.dateFrom, week.dateTo, options.dateFrom, options.dateTo);
        }
        appendTeamLevelShares(row, 'previous', week.previousLevels, data.usersInScope);
        appendTeamLevelShares(row, 'current', week.levels, data.usersInScope);
        return row;
    });
};
export var buildGeminiAdoptionTrendUserChartData = function (weeks) {
    return weeks.map(function (week) {
        var _a, _b, _c;
        var previousLevel = (_a = week.previousUserLevel) !== null && _a !== void 0 ? _a : GeminiUsageLevelEnum.ZERO;
        var currentLevel = (_b = week.userLevel) !== null && _b !== void 0 ? _b : GeminiUsageLevelEnum.ZERO;
        var teamLevel = (_c = week.teamUserLevel) !== null && _c !== void 0 ? _c : GeminiUsageLevelEnum.ZERO;
        return {
            name: week.period,
            period: week.period,
            dateFrom: week.dateFrom,
            dateTo: week.dateTo,
            previousDateFrom: week.previousDateFrom,
            previousDateTo: week.previousDateTo,
            previousLevel: previousLevel,
            currentLevel: currentLevel,
            teamLevel: teamLevel,
            previousValue: GEMINI_USAGE_LEVEL_RANK[previousLevel] + 1,
            currentValue: GEMINI_USAGE_LEVEL_RANK[currentLevel] + 1,
            teamValue: GEMINI_USAGE_LEVEL_RANK[teamLevel] + 1
        };
    });
};
export var geminiAdoptionTrendUserYAxisTickFormatter = function (t) { return function (value) {
    var level = GEMINI_USAGE_LEVELS[value - 1];
    return level ? formatGeminiUsageLevelLabel(level, true, t) : '';
}; };
export var buildGeminiAdoptionTrendExportRows = function (data, isUserView, t, i18nPrefix) {
    return data.weeks.map(function (week) {
        var _a, _b;
        if (isUserView) {
            return _a = {},
                _a[t("".concat(i18nPrefix, ".export.period"))] = week.period,
                _a[t('export.previous')] = week.previousUserLevel !== null
                    ? formatGeminiUsageLevelLabel(week.previousUserLevel, true, t)
                    : '',
                _a[t('export.current')] = week.userLevel !== null
                    ? formatGeminiUsageLevelLabel(week.userLevel, true, t)
                    : '',
                _a[t('export.teamAverage')] = week.teamUserLevel !== null
                    ? formatGeminiUsageLevelLabel(week.teamUserLevel, true, t)
                    : '',
                _a;
        }
        return __assign((_b = {}, _b[t("".concat(i18nPrefix, ".export.period"))] = week.period, _b), GEMINI_USAGE_LEVELS.reduce(function (acc, level) {
            acc["".concat(t('export.current'), " ").concat(formatGeminiUsageLevelLabel(level, true, t))] =
                "".concat(week.levels[level], " (").concat(toPercent(week.levels[level], data.usersInScope), "%)");
            acc["".concat(t('export.previous'), " ").concat(formatGeminiUsageLevelLabel(level, true, t))] =
                "".concat(week.previousLevels[level], " (").concat(toPercent(week.previousLevels[level], data.usersInScope), "%)");
            return acc;
        }, {}));
    });
};
